import { Grid } from "@mui/material";
import { AlcoholFields } from "./components/AlcoholFields";
import { SmokingFields } from "./components/SmokingFields";
import { DrugsFields } from "./components/DrugsFields";
import { ExerciseFields } from "./components/ExerciseFields";

export function SocialFields({ gender }: any) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <AlcoholFields />
      </Grid>

      <Grid item xs={6}>
        <SmokingFields />
      </Grid>

      <Grid item xs={6}>
        <DrugsFields />
      </Grid>

      <Grid item xs={6}>
        <ExerciseFields />
      </Grid>
    </Grid>
  );
}
